<template>
  <div>
    <div class="row">
      <div class="col-xl-12">
        <div class="card card-custom gutter-b card-stretch">
          <div class="card-body pt-5 pb-0 mt-n3">
            <div class="row mb-10 mt-5">
              <div class="col-md-4">
                <label class="font-size-h6 font-weight-bolder text-dark"
                  >CNPJ do parceiro</label
                >
                <b-form-input
                  class="form-control"
                  :value="form.cnpj"
                  @input="onDocumentInput"
                  maxlength="18"
                  style="text-transform: uppercase"
                  aria-describedby="input-1-live-feedback"
                ></b-form-input>
              </div>
              <div class="col-md-4">
                <button
                  type="button"
                  v-on:click="filtrar"
                  ref="submit_filtro"
                  class="btn btn-primary mt-9"
                >
                  Fitlrar
                </button>
              </div>
            </div>
            <div class="table" v-if="historico.length">
              <table class="table table-borderless table-vertical-center">
                <thead>
                  <tr>
                    <th class="p-0">Serial</th>
                    <th class="p-0">Plano</th>
                    <th class="p-0">Marcado em</th>
                    <th class="p-0">Desmarcado em</th>
                    <th class="p-0">Marcado automático</th>
                    <th class="p-0 min-w-50px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(valor, index) in historico" :key="'valor' + index">
                    <td class="pl-0">
                      <span class="text-muted font-weight-bold d-block">{{ valor.serial_completo }}</span>
                    </td>
                    <td class="pl-0">
                      <span class="text-muted font-weight-bold d-block">{{
                        valor.plano
                          ? valor.plano["descricao"]
                          : ""
                      }}</span>
                    </td>
                    <td class="pl-0">
                      <span class="text-muted font-weight-bold d-block">{{ formatDate(valor.created_at, 'DD/MM/YYYY HH:mm:ss') }}</span>
                    </td>
                    <td class="pl-0">
                      <span class="text-muted font-weight-bold d-block">{{ valor.deleted_at != null ? formatDate(valor.deleted_at, 'DD/MM/YYYY HH:mm:ss') : '' }}</span>
                    </td>
                    <td class="pl-0">
                      <span class="text-muted font-weight-bold d-block">
                        <Check v-if="valor.automatico" :size="16" />
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApplicationMixin from "@/modules/Application/mixins/SistemaMixin";
import Check from "vue-material-design-icons/Check.vue";

export default {
  name: "app-config-renovacoes-valor",
  mixins: [ApplicationMixin],
  components: {
    Check,
  },
  data() {
    return {
      historico: [],
      form: { cnpj: "" },
    };
  },
  methods: {
    onDocumentInput(value) {
      const raw = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      const hasLetter = /[A-Z]/.test(raw);

      if (!hasLetter && raw.length <= 11) {
        const n = raw;
        if (n.length <= 3) {
          this.form.cnpj = n;
        } else if (n.length <= 6) {
          this.form.cnpj = `${n.slice(0, 3)}.${n.slice(3)}`;
        } else if (n.length <= 9) {
          this.form.cnpj = `${n.slice(0, 3)}.${n.slice(3, 6)}.${n.slice(6)}`;
        } else {
          this.form.cnpj = `${n.slice(0, 3)}.${n.slice(3, 6)}.${n.slice(6, 9)}-${n.slice(9, 11)}`;
        }
      } else {
        const prefix = raw.slice(0, 12);
        const suffix = raw.slice(12, 14).replace(/[^0-9]/g, "");
        const n = prefix + suffix;
        if (n.length <= 2) {
          this.form.cnpj = n;
        } else if (n.length <= 5) {
          this.form.cnpj = `${n.slice(0, 2)}.${n.slice(2)}`;
        } else if (n.length <= 8) {
          this.form.cnpj = `${n.slice(0, 2)}.${n.slice(2, 5)}.${n.slice(5)}`;
        } else if (n.length <= 12) {
          this.form.cnpj = `${n.slice(0, 2)}.${n.slice(2, 5)}.${n.slice(5, 8)}/${n.slice(8)}`;
        } else {
          this.form.cnpj = `${n.slice(0, 2)}.${n.slice(2, 5)}.${n.slice(5, 8)}/${n.slice(8, 12)}-${n.slice(12)}`;
        }
      }
    },
    async filtrar() {
      const submitButton = this.$refs["submit_filtro"];

      try {

        if (!this.form.cnpj || this.form.cnpj == '') {
          return this.$toast.error("Informe o CPF/CNPJ do parceiro!");
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        const { data } = await this.$http.post("/renovacoes/historico/seriais", {
          cpfcnpj: this.form.cnpj
        });

        this.historico = data;

        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );

      } catch {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        return [];
      }
    },
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    config() {
      return this.layoutConfig();
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Histórico de Seriais",
      },
    ]);
  },
};
</script>
